export default "__VITE_ASSET__DGXZmUqL__"